/**
 * DTO enum for time-off type changed field names.
 * Maps to the backend TimeOffChangedFieldResponse.fieldName enum.
 */
export enum TimeOffChangedFieldNameDTO {
  ALLOCATION_FORMAT = 'ALLOCATION_FORMAT',
  NUMBER_OF_DAYS = 'NUMBER_OF_DAYS',
  RENEWAL_DAY = 'RENEWAL_DAY',
  RENEWAL_MONTH = 'RENEWAL_MONTH',
  ALLOW_CARRYOVER = 'ALLOW_CARRYOVER',
  CARRYOVER_DAYS = 'CARRYOVER_DAYS',
  MAXIMUM_BALANCE_LIMIT = 'MAXIMUM_BALANCE_LIMIT',
  ALLOW_NEGATIVE_BALANCE = 'ALLOW_NEGATIVE_BALANCE',
  NEGATIVE_BALANCE_LIMIT = 'NEGATIVE_BALANCE_LIMIT',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  ALLOW_HALF_DAY = 'ALLOW_HALF_DAY',
  ALLOW_QUARTER_DAY = 'ALLOW_QUARTER_DAY',
  ALLOW_HOURLY = 'ALLOW_HOURLY',
  CONSIDER_USER_CAPACITY = 'CONSIDER_USER_CAPACITY',
  REQUIRES_DOCUMENT = 'REQUIRES_DOCUMENT',
  IS_BILLABLE = 'IS_BILLABLE',
  CREDIT_ON_CREATION = 'CREDIT_ON_CREATION',
  PRORATE_ACCRUAL = 'PRORATE_ACCRUAL',
  UNKNOWN = 'UNKNOWN',
}

/**
 * DTO enum for time-off type changed field value keys (localizable values).
 * Maps to the backend oldValueKey / newValueKey enum.
 */
export enum TimeOffChangedFieldValueKeyDTO {
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  TRUE = 'TRUE',
  FALSE = 'FALSE',
  UNKNOWN = 'UNKNOWN',
}
